import React from 'react'
import { Dropdown } from 'react-bootstrap'

export const MenuItemTrigger = ({ onClick }) => {
  return <Dropdown.Item onClick={onClick}>Manage filters...</Dropdown.Item>
}
